import { Component, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IonSlides, ModalController } from '@ionic/angular';
import { Title } from '@angular/platform-browser';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss', '../authentication.scss']
})
export class HomePage {
  viewModel$: Observable<any> = of({
    title: "Welcome",
    loginButtonText: "Already Registered",
    registerButtonText: "Register"
  });

  slideOptions = { 
    autoplay: { 
      delay: 7000 
    }, 
    pagination: { 
      enabled: true, 
      bulletClass: 'pagination-bullet', 
      el: '.swiper-pagination', 
      type: 'bullets', 
      bulletElement: 'div' 
    } 
  }

  @ViewChild(IonSlides) slides!: IonSlides;

  //theme: string;
  selectedCountryCode: string = "au";
  selectedLanguageName: string = "english";
  
  constructor(
    private docTitle: Title,
    // private brandProvider: BrandProvider,
    // private global: GlobalizationProvider,
    private modalCtrl: ModalController,
    // private storageService: StorageProvider,
    private analyticsService: AnalyticsService,
    private router: Router,
  ) {
    this.viewModel$.subscribe(vm => this.docTitle.setTitle(vm.title));
    this.analyticsService.tagRoute('unauthenticated/home');
    // this.theme = this.brandProvider.get();
    // this.selectedCountryCode = this.global.getCountryCode();
    // this.selectedLanguageName = SUPPORTED_LOCALES_MAP[this.global.language];
  }

  goToRegister() {
    this.analyticsService.tagButtonPress('home_page', 'register');
    this.router.navigate(['unauthenticated', 'consent']);
  }
  
  goToLogin() {
    this.analyticsService.tagButtonPress('home_page', 'login');
    this.router.navigate(['unauthenticated', 'login']);
  }

  async nextSlide() {
    if (await this.slides.isEnd()) {
      this.slides.slideTo(0);
    } else {
      this.slides.slideNext();
    }
  }

  async prevSlide() {
    if (await this.slides.isBeginning()) {
      this.slides.slideTo(await this.slides.length() - 1);
    } else {
      this.slides.slidePrev();
    }
  }

  // openLanguageSelectorModal() {
  //   const languageSelectorModal = this.modalCtrl.create(
  //     'LanguageSelectorModalPage',
  //   );
  //   languageSelectorModal.onDidDismiss(data => {
  //     this.selectedCountryCode = this.global.getCountryCode();
  //     this.selectedLanguageName = SUPPORTED_LOCALES_MAP[this.global.language];
  //     if (data && data.preferredLanguage) {
  //       this.storageService.set('loggedOutLanguage', data.preferredLanguage);
  //     }
  //   });
  //   languageSelectorModal.present();
  // }


  enableSliderControls() {
    return true;
  }
}
